import React from 'react';
import FunnelSegment from './funnel_components/FunnelSegment';
import styled from 'styled-components';
import { funnel_kpis, funnel_kpi, sf_revenues } from '../../lib/Funnel'
import { DateTime } from 'luxon';
import Job from '../../lib/Job'
import FunnelChart from './funnel_components/FunnelChart';
import BarChartVsTarget from './funnel_components/BarChartVsTarget';

const Container = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
`;

const MainChartSection = styled.div`
  flex-direction: row;
  display: flex;
`;

const Column = styled.td`
  display: flex;
  flex-direction: column;
`;

const Sections = styled.div`
  display: flex;
  flex-direction: row;
`;

const FunnelDateSection = styled.td`
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ChartContainer = styled.div`
  border: 1px solid #ddd;
  padding: 20px;
`;

const BarChartContainer = styled.div`
  flex-direction: row;
  display: flex;
  flex: 1;
`;

const DetailTable = styled.table`
`;

const DetailRow = styled.tr`
`;

const DetailHeaderCell = styled.th`
  width: 100px;
  max-width: 100px;
  border: 1px solid #444;
`;

const DetailCell = styled.td`
  width: 100px;
  max-width: 100px;
  border: 1px solid #777;
`;

const FunnelDateSectionElement = styled.div`

`;

const SectionHeader = styled.div`
  font-family: Avenir-Medium;
  font-size: 25px;
  margin-bottom: 10px;
`;

const SectionHeaderLarge = styled.div`
  font-family: Avenir-Black;
  font-size: 45px;
  margin-top: 40px;
  margin-bottom: 10px;
`;

const SectionHeaderBold = styled.span`
  font-size: 25px;
  font-family: Avenir-Black;
  margin-bottom: 10px;
`;

function getDateRanges(identifier) {
  const today = DateTime.local();
  if(identifier === 'quarters') {
    return [
      [today.minus({ months: 3 }), today],
      [today.minus({ months: 6 }), today.minus({ months: 3 })],
      [today.minus({ months: 9 }), today.minus({ months: 6 })],
      [today.minus({ months: 12 }), today.minus({ months: 9 })],
      [today.minus({ months: 15 }), today.minus({ months: 12 })]
    ]
  }
  if(identifier === 'weeks') {
    return [
      [today.minus({weeks: 1}), today],
      [today.minus({weeks: 2}),today.minus({weeks: 1})],
      [today.minus({weeks: 3}),today.minus({weeks: 2})],
      [today.minus({weeks: 4}),today.minus({weeks: 3})],
      [today.minus({weeks: 5}),today.minus({weeks: 4})]
    ]
  }
  return [
    [today.minus({months: 1}), today],
    [today.minus({months: 2}),today.minus({months: 1})],
    [today.minus({months: 3}),today.minus({months: 2})],
    [today.minus({months: 4}),today.minus({months: 3})],
    [today.minus({months: 5}),today.minus({months: 4})]
  ]
}


class Funnel extends React.Component {
  state = {
    kpis: null,
    SFRevenues: null,
    mixpanelData: null,
    dateRanges: getDateRanges('weeks'),
    dateSetting: 'weeks',
    specificRows: []
  }

  componentDidMount() {
    this.getSFRevenues();
    this.getKPIs();
    this.getMixpanel();
  }

  getSFRevenues = async () => {
    const SFRevenues = await sf_revenues();
    this.setState({ SFRevenues });
  }

  getKPIs = async () => {
    const funnelKPIs = await funnel_kpis(this.state.dateRanges);
    this.setState({
      kpis: funnelKPIs
    });
  }

  getMixpanel = async () => {
    const headers = new Headers();
    headers.append('Authorization', 'Basic ' + btoa(process.env.REACT_APP_MIXPANEL_SECRET+ ":" ));
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json')
    const postingRetention = await fetch(
      `https://mixpanel.com/api/2.0/retention?from_date=2017-02-11&to_date=2019-02-11&event=Submit%20Project&born_event=Submit%20Project&interval=90&interval_count=10`,
      {
        method: 'GET',
        headers,
    }).then((response) => response.json())
    const success = Array.isArray(postingRetention)
    if (!success) return
    this.setState({
      mixpanelData: {
        posting_retention: postingRetention,
      }
    });
  }

  getKPI = async (range, id) => {
    const funnelKPI = await funnel_kpi(range, id);
    let convertedItems = [];
    if (id === 'jobs_posted' || id === 'jobs_completed') {
      convertedItems = this.convertToTableObject('jobs', funnelKPI.items);
    }
    if (id === 'users_approved' || id === 'clients_approved') {
      convertedItems = this.convertToTableObject('users',funnelKPI.items);
    }
    this.setState({ specificRows: convertedItems });
  }

  convertToTableObject = (type, items) => {
    if (type === 'users') {
      return items.map((user) => {
        return {
          name: `${user.first_name} ${user.last_name}`,
        };
      });
    }
    if (type === 'jobs') {
      const jobObjects = items.map((job) => new Job(job));
      return jobObjects.map((job) => {
        return {
          name: job.project.name,
          amount: `${job.totalRate()} ${job.currency.toUpperCase()}`,
          rate: job.rate,
          hidden: job.hidden ? 'YES' : 'NO',
          'Is booking': job.booking == true ? 'Direct Booking' : 'Posted project',
          status: job.status,
          bookee: job.bookee ? job.bookee : 'N/A',
          'Looking For': job.looking_for_data && job.looking_for_data.gender ? `${job.looking_for_data.gender} model` : job.looking_for,
          type: job.project.project_type,
          city: job.city,
          dates: job.datesString(),
        }
      })
    }
  }

  clickValue = (rangeIndex, id) => {
    this.getKPI(this.state.dateRanges[rangeIndex], id);
  }

  accurateConversionRate = (rangeObject, rateDetail) => {
    let closedJobs = rangeObject.jobs_closed.items;
    if (rateDetail === 'low_rate') {
      closedJobs = closedJobs.filter(job => job.rate< 1000);
    }
    if(rateDetail === 'high_rate') {
      closedJobs = closedJobs.filter(job => job.rate > 1000);
    }
    // What is the algorithm? If a client has a direct booking within similar time horizon, remove a job for the same talent category
    const convertedJobs = closedJobs.filter(job => job.status == 'confirmedJob' || job.status == 'completedJob');
    return convertedJobs.length / closedJobs.length;
  }

  convertValue = (value, conversion) => {
    if (conversion === 'percentage') {
      return (value * 100).toFixed(1);
    }
    return value;
  }

  target = (id) => {
    const targetsWeeks = {
      clients_approved: 100,
      conversion_rate: 50,
      projects_posted: 200,
      median_posted_value: 1200,
    };

    const targetsMonths = {
      clients_approved: targetsWeeks['clients_approved'] * 4,
      conversion_rate: targetsWeeks['conversion_rate'],
      projects_posted: targetsWeeks['projects_posted'] * 4,
      median_posted_value: targetsWeeks['median_posted_value'],
    };
    const targetsQuarters = {
      clients_approved: targetsWeeks['clients_approved'] * 12,
      conversion_rate: targetsWeeks['conversion_rate'],
      projects_posted: targetsWeeks['projects_posted'] * 12,
      median_posted_value: targetsWeeks['median_posted_value'],
    };

    let targets;
    if(this.state.dateSetting === 'weeks'){ targets = targetsWeeks;}
    if(this.state.dateSetting === 'months') { targets = targetsMonths;}
    if(this.state.dateSetting === 'quarters') { targets = targetsQuarters;}

    if(targets[id]) {
      return targets[id];
    }
    return null;
  }

  derivedData = (id, conversion = 'default') => {
    if (id === 'recurring_poster_reactivation') {
      const lastYear = this.state.kpis['unique_posters_last_year']
      const recurringPosters = this.state.kpis['projects_posted_recurring'];
      return this.mapDataBasedOnValues(recurringPosters.map((value,idx) =>{
        return value / lastYear[idx];
      }), id, conversion);
    }
  }

  mapDataBasedOnValues = (values = [], id, conversion='default') => {
    return values.map((value, idx) => {
      return {
        date: `< ${this.state.dateRanges[idx][1].toFormat('LLL dd')}`,
        value: this.convertValue(value, conversion)
      };
    }).reverse();
  }

  mapData = (id, conversion = 'default') => {
    return this.mapDataBasedOnValues(this.state.kpis[id], id, conversion);
  }

  multiMapData = (ids) => {
    const returnValue = this.state.dateRanges.map((dateRange, idx) => {
      const dataSet = {
      date:`< ${dateRange[1].toFormat('LLL dd')}`,
      }
    ids.forEach(id => {
      dataSet[id] =  this.state.kpis[id][idx]
    });
    return dataSet;
    })
    return returnValue.reverse();
  }


  referenceBarCharts = () => {
    if (!this.state.kpis) {
      return [];
    }
    return [
      {
        values: this.mapData('clients_approved'),
        target: this.target('clients_approved'),
        label: 'New Clients (Inbound)',
      },
      {
        values: this.mapData('projects_posted'),
        target: this.target('projects_posted'),
        label: 'Projects Posted',
      },
      {
        values: this.mapData('conversion_rate', 'percentage'),
        target: this.target('conversion_rate'),
        label: 'Conversion Rate (Closing Job)',
      },
    ].map(dataUnprocessed => {
      const  { values } = dataUnprocessed;
      return {
        target: dataUnprocessed.target,
        label: dataUnprocessed.label,
        value: values.length ? parseFloat(values.slice(-1)[0].value) : 0,
        pastValues: values.filter((value, idx) => idx >= values.length - 5 && idx < values. length - 1).map(item => parseFloat(item.value))
      }
    });
  }

  funnels = () => {
    if (!this.state.kpis || !this.state.mixpanelData) {
      return [];
    }
    return [
      {
        title: 'Inbound',
        productSection: 'https://docs.google.com/spreadsheets/d/1wpY6bwyFWSsAv0BVbF2W1PvnQPKxp8JWnpHuVuPOOzo/edit#gid=0',
        details: [
          {
            id: 'clients_approved',
            title: 'User signups (target-> new clients)',
            values: this.multiMapData(['clients_approved','non_clients_approved','waitlisted_users']),
            target: this.target('clients_approved'),
            isMulti: true,
            isStacked: true,
          },
        ],
      },
      {
        title: 'Posting Job',
        productSection: 'https://docs.google.com/spreadsheets/d/1wpY6bwyFWSsAv0BVbF2W1PvnQPKxp8JWnpHuVuPOOzo/edit#gid=72306613',
        details: [
          {
            id: 'projects_posted',
            title: '# of Projects Posted',
            values: this.multiMapData(['projects_posted_new','projects_posted_recurring']),
            target: this.target('projects_posted'),
            isMulti: true,
            isStacked: true,
          },
          {
            id: 'projects_posted',
            title: '# of Jobs Posted',
            values: this.mapData('jobs_posted'),
          },
          {
            id: 'median_posted_value',
            title: 'Job Value (Mean and Median)',
            values: this.multiMapData(['median_posted_value', 'mean_posted_value']),
            isMulti: true,
            target: this.target('median_posted_value')
          },
          {
            id: 'clients_approved',
            title: '% of clients who complete posting funnel, after demonstrating intent',
            isBoilerplate: true,
          },
        ],
      },
      {
        title: 'Closing Jobs',
        productSection: "https://docs.google.com/spreadsheets/d/1wpY6bwyFWSsAv0BVbF2W1PvnQPKxp8JWnpHuVuPOOzo/edit#gid=1222986644",
        details: [
          {
            id: 'conversion_rate',
            title: 'Conversion Rate',
            values: this.mapData('conversion_rate', 'percentage'),
            target: this.target('conversion_rate'),
            upperBound: 100,
          },
          {
            id: 'jobs_closed_won',
            title: '# of Jobs Closed Won (dependent value)',
            values: this.mapData('jobs_closed_won'),
            target: this.target('jobs_closed_won'),
          },
          {
            id: 'clients_approved',
            title: 'How many live jobs we\'re losing because of disintermediation',
            isBoilerplate: true,
          },
        ],
      },
      {
        title: 'Non-job Engagement + Reactivation',
        details: [
          {
            id: 'retention',
            title: 'Retention',
            type: 'retention',
            data: this.state.mixpanelData.posting_retention
          },
        ],
      },
    ];
  }

  changeDropdown = (e) => {
    this.setState({dateRanges: getDateRanges(e.target.value), dateSetting: e.target.value},()=>{
      this.getKPIs()
    });
  }

  printableDate = date => {
    const today = DateTime.local();
    if (date.get('day') == today.get('day') && date.get('month')== today.get('month')) {
      return 'Today';
    }
    return date.toFormat('yyyy LLL dd')
  }

  printableRange = (rangeIndex) => {
    if (rangeIndex == 0) {
      if (this.state.dateSetting == 'weeks') {
        return ['Last 7 days']
      }
      if (this.state.dateSetting == 'months') {
        return ['Last 30 days']
      }
    }
    return this.state.dateRanges[rangeIndex].map(dateRange => this.printableDate(dateRange));
  }

  render() {
    const x = this.funnels();
    const { specificRows } = this.state;
    const funnels = this.funnels();
    const benchmarks = this.referenceBarCharts();
    return (
      <Container>
        <SectionHeaderLarge>Vision</SectionHeaderLarge>
        <SectionHeader><SectionHeaderBold>Target User:</SectionHeaderBold> Small to Medium Clients</SectionHeader>
        <SectionHeader><SectionHeaderBold>Problem we are solving:</SectionHeaderBold> Getting them the talent they want for their shoot, optimizing for fit, and ease.</SectionHeader>
        <SectionHeaderLarge>Primary KPIs</SectionHeaderLarge>
        <select onChange={this.changeDropdown} value={this.state.value}>
          {
            [{id: 'weeks',title: 'Last few weeks'},{id: 'months', title: 'Last Few Months'}, {id: 'quarters', title: 'Last Few Quarters'}].map(range=> {
              return <option value={range.id}>{range.title}</option>
            })
          }
        </select>
        {
          funnels.length > 0 &&  this.state.SFRevenues &&
          <MainChartSection>
            <ChartContainer>
              <SectionHeader><SectionHeaderBold>Revenue</SectionHeaderBold>(excl. Smashbox)</SectionHeader>
              <FunnelChart
                title=""
                dateText=""
                defaultColor="green"
                excludeHighlight
                isPrimary
                values={this.state.SFRevenues}
                target={200000}
              />
            </ChartContainer>
            <ChartContainer>
              <SectionHeader>
                <SectionHeaderBold>
                  Key Sub KPIs
                </SectionHeaderBold>
                (This wk vs Target)
              </SectionHeader>
              <BarChartContainer>
                {
                  benchmarks.map((benchmark) => {
                    return (
                      <BarChartVsTarget
                        label={benchmark.label}
                        value={benchmark.value}
                        target={benchmark.target}
                        pastValues={benchmark.pastValues}
                      />
                    );
                  })
                }
              </BarChartContainer>
            </ChartContainer>
          </MainChartSection>

        }
        <SectionHeaderLarge>Breakdown</SectionHeaderLarge>
        <Sections>
        {
          funnels.map((section) => {
            return <FunnelSegment
              section={section}
              dateSetting={this.state.dateSetting} />;
          })
        }
        </Sections>
        {
          specificRows && specificRows.length > 0 &&
          <DetailTable>
            <DetailRow>
                {
                  Object.keys(specificRows[0]).map((key) =>
                    <DetailHeaderCell>{key}</DetailHeaderCell>
                  )
                }
            </DetailRow>
            {
              specificRows.map(item =>
                <DetailRow>
                  {
                    Object.keys(item).map(key =>
                      <DetailCell>{item[key]}</DetailCell>
                    )
                  }
                </DetailRow>
              )
            }
          </DetailTable>
        }
      </Container>
    );
  }
}

export default Funnel;